/**
 * Analytics 관련 상수
 */

// 디바운스 시간
export const PAGE_VIEW_DEBOUNCE_MS = 1000; // 1초 내 중복 방지
export const CLICK_DEBOUNCE_MS = 300; // 300ms 디바운스

// ui_target_key 기반 기본 라벨 매핑
export const UI_TARGET_LABELS = {
  event_create: '이벤트 등록',
  event_edit: '이벤트 수정',
  event_delete: '이벤트 삭제',
  event_view: '이벤트 조회',
  reservation_input: '예약담당자 입력',
  booking_create: '부킹 등록',
  booking_edit: '예약 수정',
  booking_delete: '예약 삭제',
  login_find_id_pw: '아이디/비밀번호 찾기',
  login_id_found: '아이디 골프장 선택',
  login_id_confirm: '아이디 찾기 확인',
  login_failure: '로그인 실패',
  
  // SNS 채널 관련
  sns_instagram: '인스타',
  sns_youtube: '유튜브',
  sns_kakao: '카톡채널',
  sns_blog: '블로그',
  sns_band: '밴드',
  golf_info_edit_start: '정보 입력하기',
  golf_info_save: '정보 입력 저장',
  golf_info_cancel: '골프장 정보 취소',
  
  // 담당자 관련
  contact_add: '담당자 추가',
};

/**
 * ui_target_key로부터 기본 라벨 가져오기
 */
export const getDefaultUiTargetText = (ui_target_key) => {
  if (UI_TARGET_LABELS[ui_target_key]) {
    return UI_TARGET_LABELS[ui_target_key];
  }
  
  // snake_case를 읽기 쉬운 형태로 변환
  return ui_target_key
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
